import { Component, Input, OnInit } from '@angular/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { IntegrationsService } from "@app/modules/site-settings-integrations/services/integrations.service";
import { IcimsIntegrationSettings } from '@app/modules/site-settings-integrations/models/integrations.model';

@Component({
    selector: 'app-icims-integration-details-tab',
    templateUrl: './icims-integration-details-tab.component.html',
    styleUrls: ['./icims-integration-details-tab.component.scss']
})
export class IcimsIntegrationDetailsTabComponent implements OnInit {
    @Input() integrationId: string;
    public integrationConfig: IcimsIntegrationSettings = null;

    // FORM
    formId: string = 'frm_Rci9DpUwVtfirg';
    formData: any;
    getFormData: boolean = false;
    formValid: boolean = false;
    formPristine: boolean = true;
    formLoaded: boolean = false;

    constructor(
        private translate: TranslateService,
        private snackbarService: SnackbarService,
        private overlayService: OverlayService,
        private integrationService: IntegrationsService,
    ) {
    }

    ngOnInit(): void {
        this.getData();
    }

    formDataEmitted(formDataEmitted) {
        this.save(formDataEmitted);
    }

    formStatusUpdated(formValid) {
        if (!this.formLoaded) {
            this.formLoaded = true;
        }

        this.formValid = formValid;
    }

    formPristineEmitted(formPristine: boolean) {
        this.formPristine = formPristine;
    }

    getData() {
        this.integrationService.getIcimsIntegrationConfig(this.integrationId).subscribe(res => {
            this.integrationConfig = res;

            this.buildFormData();
        })
    }

    buildFormData() {
        this.formData = {
            defaultOrganization: this.integrationConfig.defaultOrganization,
            customerId: this.integrationConfig.customerId,
            clientId: this.integrationConfig.clientId,
            clientSecret: this.integrationConfig.clientSecret,
            culture: this.integrationConfig.culture?.id,
            authenticationEndpoint: this.integrationConfig.authenticationEndpoint,
        }
    }

    save(formDataEmitted) {
        this.overlayService.show();

        formDataEmitted.defaultOrganization = formDataEmitted.defaultOrganization?.id;

        this.integrationService.updateIcimsIntegrationConfig(this.integrationId, formDataEmitted)
        .subscribe(
            {
                next: (v) => {
                    this.snackbarService.openSnackBar(this.translate.instant('IntegrationConfigUpdated'), 'clear', 'success');
                },
                complete: () => this.overlayService.hide()
            }
        );
    }
}
